import Vue from "vue";

Vue.component("static-content-child-collapse", {
	props: ["title", "description", "indexCollapse", "openIndexCollapse", "parentIndex", "openParentIndex"],
	data() {
		return {
			content: "",
			loading: true,
			titleContent: "",
			titleLoading: true,
		};
	},
	computed: {
		loadingText() {
			return window.labels.loading + "..";
		},
	},
	methods: {
		getTitleContent: function () {
			this.titleLoading = true;
			this.$services.staticContents.getContent({
					code: this.title,
					language: window.currentLanguageInt
				})
				.then((data) => {
					this.titleLoading = false;
					this.titleContent = data.content;
					this.getContent();
				});
		},
		getContent: function () {
			this.loading = true;
			this.$services.staticContents.getContent({
				code: this.description,
				language: window.currentLanguageInt
			})
				.then((data) => {
					this.loading = false;
					this.content = data.content;
				});
		},
		openInfo: function () {
			this.$emit('open-child-info', this.indexCollapse)
		}
	},
	mounted() {
		this.getTitleContent();
	},
	template: `
	  <b-collapse :open="openIndexCollapse == indexCollapse && openParentIndex == parentIndex" @open="openInfo" animation="slide">
		<template #trigger>
		  <div v-if="titleLoading" role="button">
			<loading :loading-text="loadingText"></loading>
		  </div>
		  <div v-else role="button" v-html="titleContent"></div>
		</template>
		<div class="columns m-0">
		  <div v-if="loading" class="column">
			<loading :loading-text="loadingText"></loading>
		  </div>
		  <div class="column pt-2 pb-2 collapse-border-bottom" v-html="content"></div>
		</div>
	  </b-collapse>
	`
});